import { render, staticRenderFns } from "./FilteredResults.vue?vue&type=template&id=3501a6cc&scoped=true&"
import script from "./FilteredResults.vue?vue&type=script&lang=js&"
export * from "./FilteredResults.vue?vue&type=script&lang=js&"
import style0 from "./FilteredResults.vue?vue&type=style&index=0&id=3501a6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501a6cc",
  null
  
)

export default component.exports